const API_URL = process.env.NEXT_PUBLIC_API_URL;

export const fetchAnnouncements = async () => {
  try {
    const endpoint = `${API_URL}/announcements`;

    const res = await fetch(endpoint, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
      credentials: "include",
    });

    if (!res.ok) {
      throw new Error("Failed to fetch announcements");
    }

    const data = await res.json();
    return data;
  } catch (error) {
    throw error;
  }
};

export const createEvent = async (eventData) => {
  try {
    const endpoint = `${API_URL}/createEvent`;

    const res = await fetch(endpoint, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      credentials: "include",
      body: JSON.stringify(eventData),
    });

    if (!res.ok) {
      throw new Error("Failed to create event");
    }

    const data = await res.json();
    return data;
  } catch (error) {
    throw error;
  }
};

export const fetchEventById = async (id) => {
  try {
    const endpoint = `${API_URL}/announcements/${id}`;

    const res = await fetch(endpoint, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
      credentials: "include",
    });

    if (!res.ok) {
      throw new Error("Failed to fetch event data");
    }

    const data = await res.json();
    return data;
  } catch (error) {
    throw error;
  }
};

export const fetchAnnouncementsByInstructorId = async (userId) => {
  console.log("User id", userId)
  try {
    const endpoint = `${API_URL}/announcement?instructor=${userId}`;

    const res = await fetch(endpoint, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
      credentials: "include",

    });

    if (!res.ok) {
      throw new Error("Failed to fetch announcements by instructor ID");
    }

    const data = await res.json();
    return data;
  } catch (error) {
    throw error;
  }
};

export const fetchAnnouncementsByHrId = async (userId) => {
  try {
    const endpoint = `${API_URL}/hr-announcements?hr=${userId}`;

    const res = await fetch(endpoint, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
      credentials: "include",
    });

    if (!res.ok) {
      throw new Error("Failed to fetch announcements by instructor ID");
    }

    const data = await res.json();
    return data;
  } catch (error) {
    throw error;
  }
};

export const updateAnnouncement = async (id, announcementData) => {
  try {
    const endpoint = `${API_URL}/announcements/${id}`;

    const res = await fetch(endpoint, {
      method: "PUT",
      credentials: "include",
      body: announcementData,
    });

    if (!res.ok) {
      throw new Error("Failed to update announcement");
    }

    const data = await res.json();
    return data;
  } catch (error) {
    throw error;
  }
};

export const deleteAnnouncement = async (id) => {
  try {
    const endpoint = `${API_URL}/announcements/${id}`;

    const res = await fetch(endpoint, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
      },
      credentials: "include",
      body: JSON.stringify({}),
    });

    if (!res.ok) {
      throw new Error("Failed to delete announcement");
    }

    const data = await res.json();
    return data;
  } catch (error) {
    throw error;
  }
};
export const fetchEventStudentById = async (userId) => {
  if (!userId) throw new Error("UserID is required");

  const endpoint = `${API_URL}/studentevents/${userId}`;

  const res = await fetch(endpoint, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
    credentials: "include",
  });

  if (!res.ok) {
    const errorText = await res.text();
    throw new Error(errorText || "Failed to fetch courses by user ID");
  }

  const data = await res.json();
  return data;
};

export const fetchEventId = async (id) => {
  try {
    const endpoint = `${API_URL}/eventid/${id}`;

    const res = await fetch(endpoint, {
      method: 'GET',
      headers: {
        "Content-Type": "application/json",
      },
      credentials: "include",
    });

    if (!res.ok) {
      throw new Error("Failed to fetch eventid");
    }

    const data = await res.json();
    return data;
  } catch (error) {
    throw error;
  }
};

export const markEventVideoCompleted = async (data) => {
  try {
    const endpoint = `${API_URL}/mark-video-completed`;
    const res = await fetch(endpoint, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      credentials: "include",
      body: JSON.stringify(data),
    });

    if (!res.ok) {
      throw new Error("Failed to mark video as completed");
    }

    return await res.json();
  } catch (error) {
    throw error;
  }
};

export const createEventOrder = async (orderData) => {
  try {
    const endpoint = `${API_URL}/order`;
    const res = await fetch(endpoint, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      credentials: "include",
      body: JSON.stringify(orderData),
    });

    if (!res.ok) {
      throw new Error("Failed to create order");
    }

    return await res.json();
  } catch (error) {
    throw error;
  }
};

export const sendEventPaymentEmail = async (emailData) => {
  try {
    const endpoint = `${API_URL}/mail`;
    const res = await fetch(endpoint, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      credentials: "include",
      body: JSON.stringify(emailData),
    });

    if (!res.ok) {
      throw new Error("Failed to send payment email");
    }

    return await res.json();
  } catch (error) {
    throw error;
  }
};

export const updateAnnouncementStatus = async (id, status) => {
  try {
    const endpoint = `${API_URL}/announcements/${id}/status`;

    const res = await fetch(endpoint, {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
      },
      credentials: "include",
      body: JSON.stringify({ status }),
    });

    if (!res.ok) {
      const errorData = await res.json();
      throw new Error(errorData.message || "Failed to update announcement status");
    }

    const data = await res.json();
    return data;
  } catch (error) {
    throw error;
  }
};